// src/services/DepartmentManagerService.js
//
// Who leads each department, assigned in Vero.
//
// Entra has a manager relationship and Vero reads it, but that models a
// reporting line rather than "leads this team", and maintaining it on every
// person to answer a much smaller question is a lot of upkeep. So this is an
// explicit assignment that takes precedence, with the Entra derivation left as
// the fallback for anything unassigned.

import apiClient from './apiClient'

export async function getDepartmentManagers() {
  const response = await apiClient.post('/GetDepartmentManagers', {})

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not read department managers')
  }

  // Keyed for lookup: callers ask "who leads this one", not for the list.
  const map = {}
  for (const row of response.data.managers ?? []) {
    map[`${row.country_code}|${row.department}`] = row.entra_object_id
  }
  return map
}

export async function setDepartmentManager(countryCode, department, entraObjectId) {
  const response = await apiClient.post('/SetDepartmentManager', {
    country_code: countryCode,
    department,
    entra_object_id: entraObjectId
  })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not save the manager')
  }
}

export async function clearDepartmentManager(countryCode, department) {
  const response = await apiClient.post('/ClearDepartmentManager', {
    country_code: countryCode,
    department
  })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not clear the manager')
  }
}

export function managerFor(map, countryCode, department) {
  return map[`${countryCode}|${department}`] ?? null
}
